/**
 * Created by piotr.pozniak@thebeaverhead.com on 19/02/2024
 */

import React from "react";
import Item from "./Item";

/**
 *
 * @param {boolean} disabled
 * @param {array} options
 * @param {string} label
 * @returns {Element}
 * @constructor
 */
const Dropdown = ({ disabled, options, label }) => {
  const items = options.map((i, idx) => <Item key={idx} {...i} />);

  return (
    <div className="dropdown dropdown-action">
      <a
        href={!disabled ? "#" : null}
        data-toggle={!disabled ? "dropdown" : ""}
        className="btn btn-white dropdown-toggle"
        aria-expanded="false"
      >
        {label} <i className={"material-icons"}>arrow_drop_down</i>
      </a>
      <div className="dropdown-menu dropdown-menu-right">{items}</div>
    </div>
  );
};

export default Dropdown;
